// extracted by mini-css-extract-plugin
export default {"ModalStyle":"InterfaceModal_ModalStyle__0RNOP"};